import { Modal } from "antd";

// KHAN-96: replacement for window.confirm(). It opens an antd confirmation
// modal and resolves to true only when the user presses the OK button;
// Cancel, the close icon and Esc all resolve to false, so a destructive
// action placed after `await confirmAction(...)` never runs by accident.
//
//   if (!(await confirmAction({ title: "Delete it?" }))) return;
export default function confirmAction({
  title,
  content,
  okText = "OK",
  cancelText = "Cancel",
  isDanger = false,
}) {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText,
      okButtonProps: { danger: isDanger },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
